import {combineEpics, Epic} from 'redux-observable';
import {filter, map} from 'rxjs/operators';
import {isActionOf} from 'typesafe-actions';
import {changeCurrentTrafficCenter, userIsAuthenticated} from '../../modules/UserSettingsReducer/actions';
import {getStringValueFromUrl} from '../../services/UrlService';
import trafficCenters from '../../interfaces/TrafficCenter';

const setCurrentTrafficCenterOnUserIsAuthenticated: Epic = (action$) =>
    action$.pipe(
        filter(isActionOf(userIsAuthenticated)),
        map(() => {
            const trafficCenterFromUrl = trafficCenters.find(trafficCenter => trafficCenter.name === getStringValueFromUrl('trafficCenter', ''));
            return changeCurrentTrafficCenter(trafficCenterFromUrl ? trafficCenterFromUrl : null);
        }),
    );

const trafficCenterEpics: Epic = combineEpics(
    setCurrentTrafficCenterOnUserIsAuthenticated,
);

export default trafficCenterEpics;
